<!-- <div class="page-container start-game one" [style.height.px]="screenHeight">
    <div class="content--inner">
      <div class="vertical-center-container">
        <div class="flex-inner">
          <br />
          <br />
          <main class="logo-container"  lottie [options]="options" (animationCreated)="animationCreated($event)"></main>

          <div style="width:95%; margin:auto;">
            <a
              (click)="buttonClick('/play')"
              class="play-game green--button">Play Game</a>

            <a
              (click)="buttonClick('/rhythms')"
              class="play-game grey--button">View Rhythm Deck</a>

            <a href="https://www.skillstat.com/dashboard/" target="_parent">
              <div class="logo"></div>
            </a>
          </div>
        </div>
      </div>
    </div>
</div> -->


<section id="home">

  <div class="wrapper">
    <div class="header">
      <div class="logo-container"  lottie [options]="options" (animationCreated)="animationCreated($event)"></div>
    </div>
  
    <div class="body">
      <a [routerLink] = "['/play']">
        <img class="" src="assets/practice-play.png" />
      </a>
  
      <a (click)="buttonClick('/rhythms?view=rhythms')">
        <img class="" src="assets/rhythm-deck-logo.png" />
      </a>
  
      <a (click)="buttonClick('/rhythms?view=12 lead')">
        <img class="" src="assets/lead-logo.png" />
      </a>
    </div>
  
    <div class="footer">
      <a href="https://www.skillstat.com/dashboard/" target="_parent">
        <div class="logo"></div>
      </a>
    </div>
  </div>


  
</section>
